/* local */

import type { SettingConfigSiteInfo } from './type';

// 로컬 개발망
export const localPandatv: SettingConfigSiteInfo = {
  PC_URL: 'https://local.bktv.kr',
  BASE_URL: 'https://local.bktv.kr',
  API_URL: 'api.bktv.kr',
  EVENT_URL: 'https://events.pandalive.co.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.bktv.kr/connection/websocket',
  SENTRY_DSN: undefined,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};

export const mLocalPandatv: SettingConfigSiteInfo = {
  PC_URL: 'https://local.bktv.kr',
  BASE_URL: 'https://local.m.bktv.kr',
  API_URL: 'api.bktv.kr',
  EVENT_URL: 'https://events.pandalive.co.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.bktv.kr/connection/websocket',
  SENTRY_DSN: undefined,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};

// 로컬 상망
export const productionLocalPandatv: SettingConfigSiteInfo = {
  PC_URL: 'https://local.pandalive.co.kr',
  BASE_URL: 'https://local.pandalive.co.kr',
  API_URL: 'api.pandalive.co.kr',
  EVENT_URL: 'https://events.pandalive.co.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.neolive.kr/connection/websocket',
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};

export const mProductionLocalPandatv: SettingConfigSiteInfo = {
  PC_URL: 'https://local.pandalive.co.kr',
  BASE_URL: 'https://local.m.pandalive.co.kr',
  API_URL: 'api.pandalive.co.kr',
  EVENT_URL: 'https://events.pandalive.co.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.neolive.kr/connection/websocket',
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};

// 로컬 fanza 개발망
export const localFanza: SettingConfigSiteInfo = {
  PC_URL: 'https://local.dev.pandalive.co.jp',
  BASE_URL: 'https://local.dev.pandalive.co.jp',
  API_URL: 'apidev.pandalive.co.jp',
  EVENT_URL: 'https://events.pandalive.co.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.bktv.kr/connection/websocket',
  SENTRY_DSN: undefined,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};

export const mLocalFanza: SettingConfigSiteInfo = {
  PC_URL: 'http://local.dev.pandalive.co.jp',
  BASE_URL: 'http://local.mdev.pandalive.co.jp',
  API_URL: 'apidev.pandalive.co.jp',
  EVENT_URL: 'https://events.pandalive.co.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.bktv.kr/connection/websocket',
  SENTRY_DSN: undefined,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};

/**
 * 임시로 dev 판자는 production-local-pandatv 설정을 사용;
 * 이후 fanza 설정이 완료되면 변경 필;
 */
// 로컬 fanza 상망
export const productionLocalFanza: SettingConfigSiteInfo = {
  PC_URL: 'http://local.dev.pandalive.co.jp',
  BASE_URL: 'http://local.dev.pandalive.co.jp',
  API_URL: 'dev-api.pandatv.dmm.co.jp',
  EVENT_URL: 'https://events.pandalive.co.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.bktv.kr/connection/websocket',
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};

export const mProductionLocalFanza: SettingConfigSiteInfo = {
  PC_URL: 'https://local.dev.pandalive.co.jp',
  BASE_URL: 'https://local.mdev.pandalive.co.jp',
  API_URL: 'dev-api.pandatv.dmm.co.jp',
  EVENT_URL: 'https://events.pandalive.co.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.bktv.kr/connection/websocket',
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};

// 로컬 sales
export const productionLocalSales: SettingConfigSiteInfo = {
  PC_URL: 'https://local.sales.pandalive.co.kr',
  BASE_URL: 'https://local.sales.pandalive.co.kr',
  API_URL: 'api.pandalive.co.kr',
  EVENT_URL: 'https://events.pandalive.co.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.pandalive.co.kr/connection/websocket',
  SENTRY_DSN: undefined,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};
